import type { Feature, Stat, FAQ } from './types';

export const features: Feature[] = [
  {
    id: 'feat-1',
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '实时同步全球赛事数据，比分瞬息即达，让您不错过每一个精彩瞬间',
  },
  {
    id: 'feat-2',
    icon: 'ri-global-line',
    title: '全面覆盖',
    description: '足球、篮球、网球、电竞等30+体育项目一网打尽，总有一项适合您',
  },
  {
    id: 'feat-3',
    icon: 'ri-bar-chart-box-line',
    title: '专业分析',
    description: '资深体育分析师深度解读每场比赛，帮您洞悉赛场内外的玄机',
  },
  {
    id: 'feat-4',
    icon: 'ri-live-line',
    title: '极致体验',
    description: '高清流畅的赛事直播，沉浸式的观赛体验，仿佛置身于比赛现场',
  },
];

export const stats: Stat[] = [
  { id: 'stat-1', value: '5000', label: '累计用户', suffix: '万+' },
  { id: 'stat-2', value: '100', label: '覆盖赛事', suffix: '万+' },
  { id: 'stat-3', value: '180', label: '覆盖国家', suffix: '+' },
  { id: 'stat-4', value: '30', label: '体育项目', suffix: '+' },
];

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: 'kaiyun体育平台是做什么的？',
    answer: 'kaiyun体育是一个专业的在线体育平台，为全球体育爱好者提供体育赛事资讯、赛事直播、数据分析、专业解读等全方位服务。我们覆盖足球、篮球、网球、电竞等30多个体育项目，致力于为用户提供最优质的体育内容体验。',
  },
  {
    id: 'faq-2',
    question: '如何注册kaiyun体育账号？',
    answer: '注册kaiyun体育账号非常简单。点击网站右上角的"注册"按钮，填写您的手机号码或邮箱地址，设置密码后即可完成注册。整个过程仅需1分钟，注册后即可享受全部平台服务。',
  },
  {
    id: 'faq-3',
    question: 'kaiyun体育支持哪些设备访问？',
    answer: 'kaiyun体育平台支持全设备访问。您可以通过电脑浏览器访问我们的官方网站，也可以在手机和平板设备上获得同样流畅的体验。我们采用响应式设计，自动适配不同屏幕尺寸。',
  },
  {
    id: 'faq-4',
    question: '平台上的赛事数据是否实时更新？',
    answer: '是的，kaiyun体育平台采用先进的数据同步技术，确保赛事比分、统计数据等信息实时更新。我们的数据源覆盖全球各大联赛和赛事，让您第一时间掌握赛场动态。',
  },
  {
    id: 'faq-5',
    question: 'kaiyun体育的内容是否免费？',
    answer: 'kaiyun体育平台提供大量免费的体育资讯和赛事数据。我们致力于让每一位体育爱好者都能平等地获取高质量的体育内容。部分高级功能可能需要注册账号后使用。',
  },
];